(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('WorkingDay', WorkingDay);

    WorkingDay.$inject = ['$resource'];

    function WorkingDay ($resource) {
        var resourceUrl =  'api/working-days/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
